import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import { ModalFooter } from 'components/modals/ModalFooter';
import { ModalHeader } from 'components/modals/ModalHeader';
import { useForm } from 'react-hook-form';
import { useUpdateMatterPricelistCustomNameMutation } from 'store/api/matters';
import { errorAlert } from 'utils/alert';
import { t } from 'utils/getTranslations';

interface Props {
    matterId: number;
    currentCustomName?: string;
    onClose: () => void;
}

interface FormValues {
    name: string;
}

export const EditPricelistCustomNameModal = ({ matterId, currentCustomName, onClose }: Props): JSX.Element => {
    const [updateCustomName, { isLoading }] = useUpdateMatterPricelistCustomNameMutation();
    const { control, handleSubmit } = useForm<FormValues>({
        defaultValues: { name: currentCustomName ?? '' },
    });

    const onSave = handleSubmit((form) => {
        const trimmed = form.name?.trim() ?? '';
        updateCustomName({ id: String(matterId), name: trimmed.length ? trimmed : null })
            .unwrap()
            .then(onClose)
            .catch(() => errorAlert(t('forms.error-submitting-the-form')));
    });

    return (
        <>
            <ModalHeader title={t('matters.pricelist-custom-name.title')} onCancel={onClose} />
            <div className="flex flex-col gap-2 px-6 pt-6 pb-2">
                <TextInput
                    control={control}
                    name="name"
                    label="matters.pricelist-custom-name.label"
                    placeholder="matters.pricelist-custom-name.placeholder"
                    maxLength={255}
                />
                <p className="m-0 text-sm text-zinc-500">{t('matters.pricelist-custom-name.helper')}</p>
            </div>
            <ModalFooter onCancel={onClose} onSave={onSave} disableSave={isLoading} />
        </>
    );
};
